import { Button } from '@mui/material';
import { StopStatus } from 'harmony-constants';
import { L } from 'harmony-language';
import React from 'react';
import { MAP_LINE_Z_INDEX } from '../../constants/constants';
import { calculateRoute } from '../../services/here-maps/here-map-route-service';
import { createPolyline, lineStringFromEncodedPolyline } from '../../services/here-maps/here-map-wrapper';
import { HereMapColors } from '../../styles/agistics-colors';
import { AvoidanceZone, DeviceLocation, Load } from '../../types';
import { HereMapContext } from '../here-maps/here-map-context';
import { removeMapObjectById } from '../here-maps/standard-route-helpers';

interface DriverRouteRecalculationProps {
    load: Load;
    deviceLocation: DeviceLocation;
    avoidanceZones: AvoidanceZone[];
}

export const DriverRouteRecalculation = (props: DriverRouteRecalculationProps) => {
    const { load, deviceLocation, avoidanceZones } = props;
    const [polylineId, setPolylineId] = React.useState(-1);
    const hereMapCtx = React.useContext(HereMapContext);

    React.useEffect(() => {
        return () => {
            removeMapObjectById(hereMapCtx, polylineId);
        }
    }, [polylineId]);

    function calculateStopFinish() {
        const stopEndLocation = load.stops.find(stop => stop.status === StopStatus.Enroute)?.organizationLocation;
        const waypoints = [deviceLocation, stopEndLocation];
        const callback = (result: any) => {
            const resPolyline = result.routes[0].sections[0].polyline;
            const lineString = lineStringFromEncodedPolyline(resPolyline);

            const polyline = createPolyline(lineString, {
                style: {
                    lineWidth: 4,
                    strokeColor: HereMapColors.ACTIVE,
                    lineDash: [4, 4], // [dash width, gap width]
                },
                zIndex: MAP_LINE_Z_INDEX.ActualRoute,
            });

            setPolylineId(polyline.getId());
            removeMapObjectById(hereMapCtx, polylineId);
            hereMapCtx.map.addObject(polyline);
        };
        calculateRoute(waypoints, avoidanceZones, callback);
    }

    return (
        <>
            <Button
                variant='contained'
                color='inherit'
                sx={{ position: 'absolute', top: '4em', right: '1em', zIndex: 500 }}
                onClick={calculateStopFinish}
            >
                {L.recalculateDriverRoute()}
            </Button>
        </>
    )
}